import { sharePush } from "../Services/Analytics";

var urlToShare = window.document.querySelector("meta[property='og:url']")
  .content;

const shareFacebook = () => {
  sharePush("Share From Site Head", "Facebook");
  window.open(
    "http://www.facebook.com/share.php?u=" +
      encodeURIComponent(
        urlToShare +
          `?utm_source=${window.location.hostname}&utm_medium=social&utm_campaign=facebook&utm_term=trips-memories
    `
      ),
    "_blank"
  );
};

const shareTwitter = () => {
  sharePush("Share From Site Head", "Twitter");
  window.open(
    "https://twitter.com/intent/tweet?text=" +
      encodeURIComponent(
        urlToShare +
          `?utm_source=${window.location.hostname}&utm_medium=social&utm_campaign=twitter&utm_term=trips-memories
    `
      ),
    "_blank"
  );
};

const shareWhatsapp = () => {
  sharePush("Share From Site Head", "WhatsApp");
  if (window.innerWidth < 768) {
    window.open(
      "whatsapp://send?text=" +
        encodeURIComponent(
          urlToShare +
            `?utm_source=${window.location.hostname}&utm_medium=social&utm_campaign=whatsapp&utm_term=trips-memories
      `
        ),
      "_parent"
    );
  } else {
    window.open(
      "https://web.whatsapp.com/send?phone=&text=" +
        encodeURIComponent(
          urlToShare +
            `?utm_source=${window.location.hostname}&utm_medium=social&utm_campaign=whatsapp&utm_term=trips-memories
        `
        ),
      "_blank"
    );
  }
};

const openNegishut = () => {
  sharePush("Accessibility", "Open_Accessibility_Clicked");
  window.document.getElementById("INDmenu-btn").click();
};

export { shareFacebook, shareTwitter, shareWhatsapp, openNegishut };
